import { useEffect, useState } from "react";
import './styles.js';
import { Container } from "./styles.js";
import Load from "../../../../components/load/index.js";

export default function Photos({ person_id, maximized }) {
    
    const [images, setImages] = useState({ profiles: [] });
    const [visiblePhotosPerson, setVisiblePhotosPerson] = useState(8);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {

        setLoading(true);

        const fetchPhotos = async () => {
            try {
                const response = await fetch(
                    `https://api.themoviedb.org/3/person/${person_id}/images?api_key=${process.env.REACT_APP_TMDB_KEY}`
                );
                const data = await response.json();

                if (response.ok) {
                    setImages(data);
                } else {
                    console.error("Erro ao buscar imagens:", data.status_message);
                }
            } catch (error) {
                console.error("Erro ao buscar imagens:", error);
            }

            finally {
                setLoading(false);
            }
        };

        if (person_id) fetchPhotos();
    }, [person_id]);

    // Função para carregar mais imagens
    const loadMore = () => {
        setVisiblePhotosPerson(prev => prev + 5); // Adiciona mais 5 imagens
    };

    return (
        <Container maximized={maximized}>
            {loading ?
                <Load align_center={true}/>
            :    
                <>
                    <div className="div-photos-person" id="verificar-numero-filhos">
                        {images.profiles.slice(0, visiblePhotosPerson).map(fotos => {
                            return (
                                <button
                                    className="content-photo-person"
                                    key={`foto=${fotos.file_path}`}
                                >
                                    <img
                                        loading="lazy"
                                        src={
                                            fotos &&
                                            (fotos.file_path
                                                ? `https://image.tmdb.org/t/p/w200${fotos.file_path}` // Resolução fixa
                                                : "https://dflix.netlify.app/imagens/img-erro-exclamacao.png")
                                        }
                                        alt={"foto"}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src =
                                                "https://dflix.netlify.app/imagens/img-erro-exclamacao.png";
                                        }}
                                    />
                                    <span className="span-curtidas">
                                        <i className="fa-solid fa-thumbs-up"></i>
                                        <span> {fotos.vote_count}</span>
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                    {images?.profiles?.length == 0 && <span>Não há Fotos!</span>}
                    {images.profiles && images.profiles.length > visiblePhotosPerson && (
                        <section className="section-bt-more">
                            <button onClick={loadMore}>
                                Ver Mais
                            </button>
                        </section>
                    )}
                </>
            }

        </Container>
    );
}
